import React, { useState, useRef, useEffect } from "react";
import { toast } from "sonner";
import { eventBackend } from "../../services";
import Calendar from "../../components/ui/calendarSelect";
import CalendarIcon from "../../icons/calendar";
import DateInput from "../../components/ui/dateInput";

interface ModalUpdateProps {
  event_id: number;
  onSave: () => void;
  closeModal: () => void;
}

const UpdateEventDateModal: React.FC<ModalUpdateProps> = ({
  event_id,
  onSave,
  closeModal,
}) => {
  const [statusValue, setStatusValue] = useState<number>(2);
  const [comment, setComment] = useState<string | undefined>();
  const [date, setDate] = useState<string>(""); // Состояние для даты
  const [isCalendarVisible, setIsCalendarVisible] = useState(false); // Видимость календаря
  const calendarRef = useRef<HTMLDivElement>(null); // Ref для календаря

  // Обработчик выбора даты из Calendar
  const handleDateSelect = (dateTime: string) => {
    setDate(dateTime);
    // setIsCalendarVisible(false);
  };

  // Закрытие модального окна с сохранением
  const closeWithSave = () => {
    saveAction().then((res) => {
      if (res) {
        onSave(); // Вызываем коллбэк после успешного сохранения
        closeModal(); // Закрываем модальное окно
      }
    });
  };

  // Сохранение данных
  const saveAction = async () => {
    return new Promise((resolve) => {
      if (!comment) {
        toast("Комментарий к изменениям обязателен");
        resolve(false);
        return;
      }
      eventBackend
        .updateEvent({
          event_id,
          status_id: statusValue,
          comment,
          date_end: date ? new Date(date).getTime() : undefined, // Передаём дату, если она выбрана
        })
        .then((res) => {
          toast("Событие сохранено");
          resolve(true);
        })
        .catch((e) => {
          toast("Ошибка");
          resolve(false);
        });
    });
  };

  // Обработчик клика за пределами календаря
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target as Node)
      ) {
        setIsCalendarVisible(false); // Скрываем календарь
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="editModal">
      <div className="modalHeading">
        <h3>Новая дата завершения</h3>
      </div>
      <div className="columnCenter creationForm">
        <div className="formField flex formRow">
          <label htmlFor="date">Дата завершения:</label>
          <DateInput
              value={date}
              onSelect={handleDateSelect}
            />
        </div>
        <div className="formField">
          <label htmlFor="description">Комментарий</label>
          <textarea
            id="description"
            name="description"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
          />
        </div>
      </div>
      <div className="flex between btnRow">
        <button className="filterButton" type="button" onClick={closeWithSave}>
          Сохранить
        </button>
        <button className="cancelButton" type="button" onClick={closeModal}>
          Отменить
        </button>
      </div>
    </div>
  );
};

export default UpdateEventDateModal;
